import PropTypes from 'prop-types';

import withBreakpoint from 'core/hocs/withBreakpoint';

import breakpointPropTypes from 'core/utils/prop-types/breakpoint';


function EmojiMarkupWrapper(props, { siteName }) {
  const {
    children,
    slug,
    pageType,
    breakpoint,
  } = props;

  if (!siteName || !pageType) return children({});

  const emojiMarkupProps = {
    [`data-${siteName}-${breakpoint}`]: `emoji_bar::${pageType}::${slug}`,
  };

  return children(emojiMarkupProps);
}

EmojiMarkupWrapper.propTypes = {
  slug: PropTypes.string,
  pageType: PropTypes.string,
  breakpoint: breakpointPropTypes(),
};

EmojiMarkupWrapper.contextTypes = {
  siteName: PropTypes.string,
};

export default withBreakpoint(EmojiMarkupWrapper);
